module.exports = __webpack_public_path__ + "img/no-data.f1521192.png";